import { render, staticRenderFns } from "./Lizenzverwaltung.vue?vue&type=template&id=112afdba&scoped=true"
import script from "./Lizenzverwaltung.vue?vue&type=script&lang=js"
export * from "./Lizenzverwaltung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112afdba",
  null
  
)

export default component.exports